<div class="AMFlightDetailModalContainer w-100 d-flex flex-column bg-am-medium-blue text-am-white">
  <div  class="d-flex align-items-baseline justify-content-between">
    <p class="fs-42px fw-medium">
      {{ "flightSummary.fightInfo" | translate }}
    </p>
    <img src="assets/images/close.svg" alt="close" (click)="modal.dismiss()">
  </div>
  <div class="AMFlightDetailModalHeader d-flex justify-content-start align-items-center">
    <div class="AMFlightDetailModalFare">
      <p class="fs-24px">{{ "passengerSelection.fee" | translate }}</p>
      <p class="d-lg-inline-block fs-42px fw-medium">
        <img *ngIf="urlImage" [src]="urlImage" alt="fare"> {{ 'fares.'+ ( fareFamily === FARES_FAMILY.AMPLUS? "AMPlus": (fareFamily| titlecase) ) +'.fareFamily' | translate}}</p>
    </div>
    <div class="AMFlightDetailModalBagResume fs-24px fw-regular ">
      <p><img src="assets/images/bags/baggagePolicy.svg" alt="Carryon">
        {{ 'fares.Basic.fareBasicBenefit'  | translate }} {{ fareWeight }} kg
      </p>
      <p class="d-lg-inline-block "> <img *ngIf="urlImage" [src]="urlImage" alt="Fare">
        {{ 'fares.'+ ( fareFamily === FARES_FAMILY.AMPLUS? "AMPlus": (fareFamily| titlecase) ) +'.fare'+( fareFamily === FARES_FAMILY.AMPLUS? "AMPlus": (fareFamily| titlecase) )+'Seat' | translate}}
      </p>
    </div>
  </div>
  <div>
    <div class="am-table">
      <div class="am-thead">
        <div class="am-table-row-header d-flex justify-content-start">
          <div
            class="fs-15px am-height-table-column-header am-table-columns-description d-flex justify-content-start align-items-center bags-column-width pl-4"
            style="color: rgba(255, 255, 255, 0.6); text-transform: uppercase;">
            {{ 'seatReview.titlePassengers' | translate }}
          </div>
          <div class="am-table-column am-border-radius-header mx-3 bags-column-width opacity-50">
            {{ 'luggageRules.checkedBaggage' | translate |uppercase}}
          </div>
          <div class="fs-15px am-table-column pl-4 seats-column-width"
               style="color: rgba(255, 255, 255, 0.6); text-transform: uppercase;"
          >
            {{  "flightSummary.seats"| translate | uppercase}}
          </div>

        </div>
      </div>
      <app-am-scroll  [height]="270">
        <div class="am-tbody am-scroll">
          <div class="am-table-row" *ngFor="let passenger of passengers; let iPassenger = index"
               style="margin-bottom: 12px;">
            <div class="am-table-columns-description bags-column-width d-flex flex-column justify-content-center align-items-start">
              <p class="name fs-24px mb-0">{{ passenger.displayName | titlecase }}
              </p>
              <p class="fs-15px mb-1" *ngIf="passenger.hasInfant">
                {{ 'flightSummary.infant' | translate }}
              </p>
            </div>
            <div class="am-table-column-seat mx-3 fs-24px fw-regular bags-column-width p-3 d-flex justify-content-center align-items-start align-items-center flex-column"

            >
              <p class="mb-0" *ngIf="countBags[iPassenger].bags25 === 0">
                <img src="assets/images/Checked_Bag_none.svg" alt="Bag non checked">
                {{ 'flightSummary.whitoutBag' | translate }}
              </p>
              <p class="mb-0" *ngIf="countBags[iPassenger].bags25 as count25" alt="Bag 20 checked" class="img-bag">
                <img src="assets/images/bags/icon-bag-trash.svg"> {{ count25 }} {{ 'luggageRules.checkedBaggage' | translate}} {{  fareFamily === FARES_FAMILY.PREMIER ? 32 : 25 }} kg
              </p>
            </div>
            <div class="am-table-column-price seats-column-width d-flex justify-content-center align-items-start fs-24px p-3 flex-column"
            >
              <p class="fs-24px fw-regular text-am-white mb-0" *ngIf="countBags[iPassenger]?.seat else SeatNull">
                {{ countBags[iPassenger]?.seat }} {{  countBags[iPassenger].type | seatubication }}
              </p>
              <ng-template #SeatNull>
                <p class="fs-24px fw-regular text-am-white opacity-50 mb-0">{{ "flightSummary.whitoutSelection" | translate }}</p>
              </ng-template>

            </div>
          </div>
        </div>
    </app-am-scroll>
    </div>
  </div>
</div>
